import { gql } from "@apollo/client";
export default gql`
  mutation ClearSMSCLink {
    clearSMSCLink
  }
`;
